import { gql } from 'graphql-tag';

export const cpaasTnFields = `
  id
  did
  tnE164
  customerId
  voiceServiceId
  messagingServiceId
  createdAt
  updatedAt
  status
`;

const voiceSettings = `
  {
    trunkSettings {
      id
      sansayTrunkId
      name
      alias
    }
    serviceSettings {
      id
    }
    portOutSettings {
      portOutPin
    }
    outboundCallerSettings {
      enabled
      outboundCallerIdName
    }
    callForwardingSettings {
      enabled
      destination
    }
    stirShakenSettings {
      noTokenBlocked
      errorValidatingBlocked
      invalidTokenBlocked
      noTokenAllowed
      errorValidatingAllowed
      invalidTokenAllowed
    }
    inboundCnamSettings {
      cnamDippingEnabled
      reputationScoringEnabled
      reputationSettings {
        warningScore
        warningAction
        alarmScore
        alarmAction
      }
    }
    netsapiensSettings {
      enabled
      domainId
      domainDescription
    }
  }
`;

const messagingSettings = `{
  smsEnabled
  smsConfigId
  smsConfigName
  smsConfigAlias
  campaignId
  mmsEnabled
  mmsRouteId
  mmsRouteName
  mmsRouteAlias
}`;

export const cpaasTnDetailFields = `
  ${cpaasTnFields}

  status
  voiceServiceName
  voiceServiceRootPath
  subAccountId
  subAccountName
  trunkId
  trunkName
  cnam

  usedBy {
    id
    name
    type
    extensionNumber
    status
  }

  currentSettings {
    voiceSettings ${voiceSettings}
    messagingSettings ${messagingSettings}
  }
`;

export const CpaasTnsForCustomerQuery = gql`
  query cpaasTnsForCustomer($input: CpaasTnsForCustomerFilter!) {
    cpaasTnsForCustomer(input: $input) {
      ${cpaasTnFields}
    }
  }
`;

const didExtensionsFields = `
  did
  extension
  name
`;

export const customerDidsExtensionsQuery = gql`
  query customerDidsExtensions($customerId: Int!) {
    customerDidsExtensions(customerId: $customerId) {
      ${didExtensionsFields}
    }
  }
`;

export const syncServiceExtensionsMutation = gql`
  mutation syncServiceExtensions($input: SyncServiceExtensionsInput!) {
    syncServiceExtensions(input: $input) {
      ${didExtensionsFields}
    }
  }
`;

export const CpaasTnDetailsForCustomerQuery = gql`
  query cpaasTnDetailsForCustomer($input: CpaasTnDetailsForCustomerFilter!) {
    cpaasTnDetailsForCustomer(input: $input) {
      totalCount
      tnDetails {
        ${cpaasTnDetailFields}
      }
    }
  }
`;

export const importTnsForCustomerMutation = gql`
  mutation importTnsForCustomer($input: ImportTnsForCustomerInput!) {
    importTnsForCustomer(input: $input) {
      ${cpaasTnDetailFields}
    }
  }
`;

export const uploadTnsForCustomerUsMutation = gql`
  mutation uploadTnsForCustomerUs($input: UploadTnsForCustomerUsInput!) {
    uploadTnsForCustomerUs(input: $input) {
      ${cpaasTnDetailFields}
    }
  }
`;

export const CpaasVendorsQuery = gql`
  query getCpaasVendors {
    getCpaasVendors {
      vendorList
    }
  }
`;

export const addCpaasVendorMutation = gql`
  mutation addCpaasVendor($vendor: String!) {
    addCpaasVendor(vendor: $vendor) {
      vendorList
    }
  }
`;

export const e999CallRoutesQuery = gql`
  query getE999CallRoutes($input: E999CallRoutesInput!) {
    getE999CallRoutes(input: $input) {
      totalCount
      e999CallRoutes {
        name
        tnE164
        premises
        thoroughfare
        locality
        postCode
        status
      }
    }
  }
`

export const addE999CallRouteMutation = gql`
  mutation addE999CallRoute($input: ManageE999CallRouteInput!) {
    addE999CallRoute(input: $input)
  }
`

export const editE999CallRouteMutation = gql`
  mutation editE999CallRoute($input: ManageE999CallRouteInput!) {
    editE999CallRoute(input: $input)
  }
`

export const deleteE999CallRouteMutation = gql`
  mutation deleteE999CallRoute($input: ManageE999CallRouteInput!) {
    deleteE999CallRoute(input: $input)
  }
`

export const e999CallRouteAuditQuery = gql`
  query getE999CallRouteAudit($input: E999CallRouteAuditInput!) {
    getE999CallRouteAudit(input: $input) {
      totalCount
      e999CallRouteAudit {
        customerId
        action
        currentRecord
        previousRecord
        createdAt
      }
    }
  }
`
